<template>
  <modal
    effect="fade/zoom"
    cancelText="Fermer"
    okText="Enregistrer"
    v-model="isOpen"
    @ok="newOrder"
    @cancel="$emit('close')"
  >
    <div slot="modal-header" class="modal-header row m-0">
      <h4 class="modal-title col-8">Ajouter une commande B2B</h4>

      <div
        class="col-4 d-flex flex-column align-items-end"
        style="padding-top: 17px"
      >
        <div class="pull-right d-flex flex-wrap justify-content-end">
          <div class="form-group d-inline-block mr-1">
            <div class="form-group d-inline-block">
              <span class="mr-1"><i class="icon-envelope"></i> Email</span>
              <label
                class="switch switch-sm switch-text switch-info float-right mb-0 mr-0"
              >
                <input
                  type="checkbox"
                  class="switch-input"
                  v-model="form.sendEmail"
                  :disabled="!hasPermission($store.state.user, 'ORDERS_WRITE')"
                />
                <span class="switch-label" data-on="On" data-off="Off"></span>
                <span class="switch-handle"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-sm-8">
        <label>Pack</label>

        <v-select v-model="form.session" :options="sessions"></v-select>
      </div>
      <div class="form-group col-sm-4" style="padding-top: 14px">
        Pointage des participants
        <label
          class="switch switch-sm switch-text switch-info float-right mb-0 mr-0"
        >
          <input
            type="checkbox"
            class="switch-input"
            v-model="form.requiredSessionUserCount"
            :disabled="!hasPermission($store.state.user, 'ORDERS_WRITE')"
          />

          <span class="switch-label" data-on="On" data-off="Off"></span>

          <span class="switch-handle"></span>
        </label>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-sm-12">
        <label> Description commande (visible facturation) </label>

        <v-select
          style="margin-bottom: 5px"
          :options="client.orderDescriptions"
          v-model="client.billing.label"
          @input="updateBillingDescriptionForB2B"
        ></v-select>

        <textarea
          v-model="client.billing.description"
          type="text"
          class="form-control"
        />
      </div>
      <div class="form-group col-sm-12">
        <label> Label de la commande (visible coach) </label>

        <textarea v-model="form.label" type="text" class="form-control" />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-sm-12">
        <label>Menu / Statistique *</label>
        <v-select
          v-model="form.menuStat"
          :options="menuStatsOptions"
          label="label"
          :selectable="(option) => !option.disable"
          :class="this.formErrors.menuStat ? 'has-error' : ''"
        />
      </div>
    </div>

    <div class="row mt-1">
      <div class="form-group col-sm-12">
        Suivi de planification
        <label class="switch switch-sm switch-text switch-info ml-1 mb-0 mr-0">
          <input
            v-model="form.sessionScheduleTracking"
            type="checkbox"
            class="switch-input"
          />

          <span class="switch-label" data-on="On" data-off="Off"></span>

          <span class="switch-handle"></span>
        </label>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import Modal from "vue-strap/src/Modal";

export default {
  components: {
    Modal,
  },

  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    clientData: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isOpen: false,
      sessions: [],
      client: null,
      formSending: false,

      form: {
        client: null,
        description: null,
        label: null,
        menuStat: null,
        requiredSessionUserCount: null,
        sendEmail: true,
        session: null,
        sessionScheduleTracking: true,
      },

      formErrors: {
        client: null,
        menuStat: null,
        session: null,
      },
    };
  },

  computed: {
    ...mapGetters({
      menuStatsOptions: "getMenuStatsOptions",
    }),
  },

  watch: {
    isShow(val) {
      this.isOpen = val;
    },

    clientData(val) {
      this.client = val;
    },
  },

  created() {
    this.isOpen = this.isShow;
    this.client = this.clientData;

    if (this.client.orders.length > 0) {
      this.form.menuStat = this.menuStatsOptions.find(
        (m) => m.value === "pack-fidelisation",
      );
    } else {
      this.form.menuStat = this.menuStatsOptions.find(
        (m) => m.value === "pack-conversion",
      );
    }

    for (let i = 1; i <= 200; i++) {
      this.sessions.push({
        label: this.formatPack(i.toString()),
        value: i.toString(),
      });

      if (!this.form.session) {
        this.form.session = this.sessions[0];
      }
    }
  },

  methods: {
    updateBillingDescriptionForB2B(value) {
      this.client.billing = {
        ...this.client.billing,
        description: value ? value.description : "",
        label: value ? value.label : "",
      };
    },

    checkFields() {
      this.formErrors.client = !this.form.client;
      this.formErrors.menuStat = !this.form.menuStat;
      this.formErrors.session = !this.form.session;

      return (
        !this.formErrors.menuStat &&
        !this.formErrors.session &&
        !this.formErrors.client
      );
    },

    async newOrder() {
      this.form.client = this.client.email;
      this.form.description = this.client.billing.description;

      const commercial = this.$store.state.user.commercial?.isCommercial
        ? this.$store.state.user.email
        : this.client.commercials.sort((a, b) =>
            moment(b.relatedSince).diff(moment(a.relatedSince)),
          )[0].user;

      if (!this.form.client || this.formSending) {
        this.$errorToast("Les informations du client sont manquantes");
        return;
      }

      const isConversion =
        this.form.menuStat &&
        this.form.menuStat.value &&
        (this.form.menuStat.value === "decouverte" ||
          this.form.menuStat.value === "one-shot");

      const isAcquisition =
        this.form.menuStat &&
        this.form.menuStat.value &&
        (this.form.menuStat.value === "decouverte" ||
          this.form.menuStat.value === "pack-conversion" ||
          this.form.menuStat.value === "one-shot" ||
          this.form.menuStat.value === "autres");

      const isFidelisation =
        this.form.menuStat &&
        this.form.menuStat.value &&
        (this.form.menuStat.value === "pack-conversion" ||
          this.form.menuStat.value === "pack-fidelisation" ||
          this.form.menuStat.value === "one-shot");

      try {
        this.$emit("orderLoading", true);
        this.formSending = true;

        const { data } = await this.$api.post("/orders", {
          client: this.form.client,
          commercial,
          concept: "Corporate",
          isAcquisition,
          isConversion,
          isFidelisation,
          isOneShotEvent: this.form.menuStat?.value === "one-shot",
          description: this.form.description,
          label: this.form.label,
          labelDescription: this.client.billing.label,
          merchantId: this.$store.state.merchantIds.corporate,
          price: "0",
          requiredSessionUserCount: this.form.requiredSessionUserCount,
          session: this.form.session.value,
          sessionScheduleTracking: this.form.sessionScheduleTracking,
        });

        if (this.form.sendEmail) {
          this.$confirm({
            message: "Envoyer un email pour informer le client ?",
            onConfirm: async () => {
              await this.$api.post(`/orders/send-creation-email/${data.id}`);
            },
          });
        }

        this.$emit("success", data);
        this.$emit("close");
      } catch (err) {
        this.formSending = false;

        this.$errorToast(
          err.response?.data?.message ||
            "Une erreur est survenue lors de la création de la commande.",
        );
      } finally {
        this.$emit("orderLoading", false);
      }
    },
  },
};
</script>
